import { FunctionComponent } from 'react';
import { useParams } from 'react-router';
import { GetPositionConfigurationResponse } from '@/shared/types/positionV2/api/get-position-configuration.ts';
import { usePositionV2 } from '@/clients/position/usePositionV2.ts';

export type PositionLoaderComponentProps = {
    positionV2?: GetPositionConfigurationResponse;
    order?: { positionId: string | null };
};

export function PositionLoader<ComponentProps extends PositionLoaderComponentProps>(
    Component: FunctionComponent<ComponentProps>
) {
    function WithPosition({ positionId }: { positionId: string }) {
        const { data: positionV2, isError, error } = usePositionV2(positionId);

        if (isError) {
            throw new Error(error.message);
        }

        return (props: ComponentProps) => <Component positionV2={positionV2} {...props} />;
    }

    return function PositionLoaderRenderer(props: ComponentProps) {
        const { positionId: searchPositionId } = useParams<{ positionId: string }>();
        const positionId = searchPositionId ?? props.order?.positionId;

        if (!positionId) {
            return <Component {...props} />;
        }

        return WithPosition({ positionId })(props);
    };
}
